import { AppData, Lightning, Router } from "@lightningjs/sdk";
import { Helper } from "../lib/helper";
import { AppSetup } from "../lib/app-setup";

export default class VideoResumeBar extends Lightning.Component {
  _duration: any;
  _resumeTime: any;
  static override _template() {
    return {        
      //h: 16,
      w: (w: any) => w,
      Progress: {        
        rect: true,
        shader: {type: Lightning.shaders.RoundedRectangle, radius: 0},
        x: 0,
        y: 0,
        w: (w: any) => w,
        h: (h: any) => h,
        color: 0x00ff0000,
        InnerProgress: {
          rect: true,
          shader: {type: Lightning.shaders.RoundedRectangle, radius: 0},
          color: 0xfff34966,
          x: 0,
          y: 0,
          w: (w: any) => 0,
          h: (h: any) => h,
        },
      },
      visible:false
    };
  }

  override _active(){
    if(this.visible){        
        this.updateProgress();
    }
  }

  set item(item:any){
    let activeRoute = Router.getActiveRoute();
    if(activeRoute && activeRoute.indexOf('video-screen')>-1){
        return;
    }
    let isVideo = item && item.actiontype=="video"    
    if(!isVideo){
        return;
    }    
    this.updateResumeTime(item);
  }  

  set duration(v) {
    this._duration = v;
  }

  get duration() {
    return this._duration || 0.0001;
  }

  set resumeTime(v) {
    this._resumeTime = v;
  }

  get resumeTime() {
    return this._resumeTime || 0;
  }

  updateProgress() {    
    const ratio = Math.round((this.resumeTime / this.duration) * 1000) / 1000;
    this.tag("Progress.InnerProgress").setSmooth(
      "w",
      this.renderWidth * ratio
    );
  }

  updateResumeTime(videoInfo:any){
    const { appConfig, appState } = AppData as AppSetup;
    const appApiConfig = appState?.getAppApiConfig()
    let resumeTime:any;
      if(appConfig?.useLocalStorage == true) {
          resumeTime = localStorage.getItem(videoInfo.node_id);	
      } else {
          resumeTime = Helper.getCookie(videoInfo.node_id);
      }    
      if(resumeTime !== "" && resumeTime !== null && resumeTime !== 0 && (appApiConfig?.appConfig?.resumeVidMinDuration && videoInfo.runtime > appApiConfig?.appConfig?.resumeVidMinDuration)) {          
        this.duration = videoInfo.runtime;
        this.resumeTime = parseInt(resumeTime);        
        this.visible = true;
    }
  }
}
